import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Overlay from 'components/Overlay';

const UpsellConfirm = ({
  backgroundUrl,
  theme,
  sharedTheme,
  children,
  innerContainerChildren,
  rendered,
  backgroundClass,
  innerContainerChildrenParams,
}) => (
  <Overlay
    backgroundClass={backgroundClass}
    backgroundUrl={backgroundUrl}
    sharedTheme={sharedTheme}
    theme={theme}
    rendered={rendered}
    innerContainerChildren={innerContainerChildren}
    innerContainerChildrenParams={innerContainerChildrenParams}
  >
    <div className={classNames(sharedTheme.innerContainer, theme.innerContainer)}>{children}</div>
  </Overlay>
);

UpsellConfirm.defaultProps = {
  backgroundUrl: null,
  sharedTheme: {},
  innerContainerChildrenParams: null,
  theme: null,
  children: null,
  innerContainerChildren: () => {},
  rendered: false,
  backgroundClass: '',
};

UpsellConfirm.propTypes = {
  backgroundUrl: PropTypes.string,
  theme: PropTypes.shape({}),
  sharedTheme: PropTypes.shape({}),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  innerContainerChildren: PropTypes.func,
  rendered: PropTypes.bool,
  backgroundClass: PropTypes.string,
  innerContainerChildrenParams: PropTypes.shape({}),
};

export default UpsellConfirm;
